import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import reportBr11Action from '~/modules/master/redux/actions/report-br11'

const useReportBr11 = () => {
  const data = useSelector((state) => get(state, 'master.reportBr11'))

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(reportBr11Action, dispatch),
    [dispatch],
  )
  return {
    actions,
    data,
  }
}

export default useReportBr11
